import { ClinicalTrialContextState } from '@restore/clinicalTrialContext/clinicalTrialContext.types';

export const findVisitConfigById = (
  contextData: ClinicalTrialContextState['data'],
  visitDefinitionId: string
) => {
  if (!contextData?.configuration?.cohorts) {
    return null;
  }

  const foundVisit = contextData.configuration.cohorts
    .flatMap(({ visits }) => visits)
    .find(v => v.id === visitDefinitionId);

  return foundVisit || null;
};
